'use client'

import Script from 'next/script'

export function Analytics() {
  // Plausible Analytics Configuration
  const plausibleDomain = process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN
  const plausibleScriptUrl = process.env.NEXT_PUBLIC_PLAUSIBLE_SCRIPT_URL
  
  // Google Analytics Configuration
  const gaId = process.env.NEXT_PUBLIC_GA_ID
  
  return (
    <>
      {/* Plausible Analytics */}
      {plausibleDomain && plausibleScriptUrl && (
        <>
          <link rel="dns-prefetch" href={new URL(plausibleScriptUrl).origin} />
          <Script
            defer
            data-domain={plausibleDomain}
            src={plausibleScriptUrl}
            strategy="afterInteractive"
          />
        </>
      )}
      
      {/* Google Analytics */}
      {gaId && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
            strategy="afterInteractive"
          />
          <Script id="google-analytics" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gaId}');
            `}
          </Script>
        </>
      )}
    </>
  )
}